import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuMmaxInterface } from '../etc/mmax-menu.interface';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'app-mmax-end-line-cp',
  templateUrl: './mmax-end-line-cp.component.html',
  styleUrls: ['./mmax-end-line-cp.component.scss']
})
export class MmaxEndLineCpComponent implements OnInit, OnDestroy {
  @Input('mode') modo: string;
  countdown: number = 5;
  private timerInterval: any;

  constructor(private serv: MarianomGeneral, private router: ActivatedRoute) {
    this.modo = this.modo || 'normal';
    this.womencart = '../../assets/misc/compra.png';
  }

  ngOnInit(): void {
    this.disableBack();

    // Limpieza segura de elementos de Mercado Pago que podrían quedar en el DOM
    const mpWrappers = document.getElementsByClassName("mp-mercadopago-checkout-wrapper");
    Array.from(mpWrappers).forEach(el => el.remove());

    const bodyPage = document.querySelector('body');
    if (bodyPage) {
      bodyPage.style.cssText = '';
    }

    this.router.data.subscribe(data => {
      this.modo = data['mode'] || this.modo || 'normal';
    });
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startCountdown() {
    this.timerInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.timerInterval);
        this.volverAchan();
      }
    }, 1000);
  }

  disableBack() {
    window.onhashchange = function () {

      if (window.location.hash === "#/checkout/finalizar") {

        window.location.hash = "#/checkout/finalizadocp";
      }
    }
  }

  volverAchan() {
    for (let i = 0; i < this.menus.length; i++) {
      const element = this.menus[i];
      element.activo = false;
    }
    this.serv.navigator.goLandPage(this.router);
  }

  get menus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }

  womencart: string;
}
